import React, { createContext, useState } from "react";
import { useForm } from "react-hook-form";
import RegisterForm from "./RegisterForm";







enum RegisterState{
  unauthorized,
  authorized,
  registered,
}
let registerState:RegisterState=RegisterState.unauthorized;
//registerState=RegisterState.authorized;
let currentPW:string="";

export function Register(){
   const [, forceUpdate] = React.useState(0);
   const setRegisterState=(state:RegisterState)=>{
    forceUpdate(n => n + 1); // Incrementing forces a re-render
    registerState=state;
   }
  const [ wrongPW, setWrongPW ] = useState(false);
  const { register, handleSubmit, formState: { errors, isValid } } = useForm({ mode: "onChange" });
  const onSubmit = async (data:any) => {
    try {
      const response = await fetch('/api/checkPW', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        console.log("sending data:",data);
        //setCurrentPW(data.password)
        currentPW=data.password;
        setRegisterState(RegisterState.authorized)
      } else {
        console.log('Error submitting form');
        setWrongPW(true);
      }
    } catch (error) {
      console.error('Error:', error);
        alert("upps 1 Server Fehler")
    }
  };
    return (<>
        {registerState==RegisterState.unauthorized&&
            <>
              <form className='form'  onSubmit={handleSubmit(onSubmit)} method="POST">
              <h2 style={{textAlign: "center"}}>Hallo!</h2>
              <h3 style={{textAlign: "center"}}>schön dass du Mitglied werden möchtest :)</h3>
              <h3 style={{textAlign: "center"}}>Um dem Verein beitreten zu können, benötigst du ein Passwort, welches du von uns persönlich bekommst.</h3>
              <br></br>
              <label >Passwort:</label>
              <input type="password" {...register('password', { required: true })}placeholder='Geheim!' id="password" name="password"/><br/><br/>
              {wrongPW && <p style={{display: "block", textAlign:"left", color: "red"}}>Falsches Passwort? <br></br> Das Passwort bekommt ihr von uns.</p>}
              <input type="submit" value="Sesam öffnen!" /*disabled={!isValid}*/ />
              </form>
            </>
        }
        {registerState==RegisterState.authorized&&
            <RegisterForm password={currentPW} setRegisterState={setRegisterState}/>
        }
        {registerState==RegisterState.registered&&
            <>
                <h2>Vielen Dank</h2>
                <h3>Du bist nun Angemeldet.</h3>
            </>
        }
    </>);
}
